<template>
  <div class="modal_card">
    <div class="modal_form">
      <i @click="$emit('close-modal')" class="icon-close"></i>
      <h1>Добавить с помощью Excel</h1>
      <form @submit.prevent="submitFile">
        <b-field class="file">
          <b-upload v-model="file"  id="file">
            <i v-if="!file" class="mdi mdi-upload"></i> {{ file ? file.name : 'Выберите файл' }}
          </b-upload>
        </b-field>

        <button class="add_user_button modal_button left_button" type="submit">
          Добавить
        </button>
        <button @click="$emit('close-modal')" class="close_button modal_button right_button">Отмена</button>
      </form>
    </div>
  </div>
</template>

<script>
import { toastDanger } from '@/lib/toastCfg'

export default {
  data() {
    return {
      file: null
    }
  },
  methods: {
    submitFile() {
      if (this.fileValidation()){
        this.$emit('save', this.file)
      } else {
        this.$buefy.toast.open(toastDanger('Добавьте таблицу'))
      }
   },
    fileValidation() {
      this.allowedExtensions =  /(\.xls|\.xlsx)$/i;
      if (!this.allowedExtensions.exec(this.file.name)) {
        return false;
      } 
      return true;
    }
  },
}
</script>
